import type { FormInstance }   from 'antd';
import React                   from 'react';
import { Col }                 from 'antd';
import { Form }                from 'antd';
import Row                     from 'components/App/Row';
import Input                   from 'components/App/IntlInput';
import Select                  from 'components/App/IntlSelect';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import handleApiError          from 'utils/handleApiError';
import type { RefObject }      from 'react';
import { ApiCollection }       from 'collections/ApiCollection';
import { AppFormComponent }    from 'components/App/AppForm';
import AdvertiserShowModel     from 'models/AdvertiserShowModel';
import handleFormError         from 'utils/handleFormError';
import { messageSuccessIntl }  from 'utils/messageIntl';

const { Option } = Select;

// import {
//   LINK_TYPE_MAILTO,
//   LINK_TYPE_WEBSITE,
// } from '../../../constants/ProviderLinkTypes';

interface AdvertiserShowFormProps {
  advertiserCollection: ApiCollection;
  model: AdvertiserShowModel;
  onSuccess?: (model: AdvertiserShowModel) => void;
}

class AdvertiserShowForm extends AppFormComponent<AdvertiserShowFormProps> {
  public formRef: RefObject<FormInstance> = React.createRef<FormInstance>();

  public componentDidMount() {
    const { model } = this.props;

    this.formRef.current?.setFieldsValue({
      advertiser: model.get('advertiser'),
      link: model.get('link'),
      wording: model.get('wording'),
    });
  }

  public render() {
    const { advertiserCollection } = this.props;

    return (
      <Form className="antd-form-custom-style" ref={this.formRef}>
        <Row>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Annonceur" />}
              labelCol={{ span: 24 }}
              name="advertiser"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Annonceur manquant" />,
                  required: true,
                },
              ]}
            >
              <Select
                onChange={(value: any) => {
                  const advertiserFound = advertiserCollection.find(
                    advertiser => advertiser.get('@id') === value,
                  );
                  if (advertiserFound) {
                    this.formRef.current?.setFieldsValue({
                      link: advertiserFound.get('link'),
                    });
                  }
                }}
              >
                {advertiserCollection.map(advertiser => (
                  <Option key={advertiser.id} value={advertiser.get('@id')}>
                    {advertiser.get('name')}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Libellé" />}
              labelCol={{ span: 24 }}
              name="wording"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Libellé manquant" />,
                  required: false,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={12} md={18}>
            <Form.Item
              label={<FormattedMessageWrapper id="Lien" />}
              labelCol={{ span: 24 }}
              name="link"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Lien manquant" />,
                  required: false,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const values = await this.formRef.current?.validateFields();

    try {
      await this.handleSubmit(values);
    } catch (error) {
      handleApiError(error);
    }
  };

  private handleSubmit = async (values: any) => {
    const {
      model,
      onSuccess,
    } = this.props;

    model.set(values);

    try {
      await model.save();

      messageSuccessIntl("Annonce enregistrée !");

      if (onSuccess) {
        onSuccess(model);
      }

      this.formRef.current?.resetFields();
    } catch (err) {
      handleFormError(err, this.formRef.current);
    }
  };
}

export default AdvertiserShowForm;
